import { CSV } from '../../../cimsPage/instances/importsExports'
import { Simple } from '../../common'

const object = 'CSV'
const page = CSV

export const ImportCSV = Simple({
  id: '94A4F3A9-8C39-45E9-91B7-3A8766001A35',
  action: 'Import',
  object,
  page,
})

export const ExportCSV = Simple({
  id: '02BB6DD8-9BC1-4FEF-BC27-BF2801953234',
  action: 'Export',
  object,
  page,
})

export type ImportExportCSVPermission = typeof ImportCSV | typeof ExportCSV
